module.exports = antd.Image;